import { Clock, Users, ArrowUpRight } from "lucide-react";
import { clp, minPrice, OVERNIGHT, PRICE_MODE_LABEL } from "@/lib/format";
import { mediaUrl } from "@/lib/api";

function ExperienceCard({ e, onSelect, i }) {
  const p = minPrice(e);
  const overnight = OVERNIGHT.includes(e.slug);
  return (
    <article data-testid={`experience-card-${e.slug}`}
      className={`group rounded-3xl overflow-hidden bg-white border border-border flex flex-col transition-transform duration-500 hover:-translate-y-1 ${i % 3 === 1 ? "lg:translate-y-10" : ""}`}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={mediaUrl(e.image)} alt={e.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute top-4 left-4 rounded-full bg-[#FAF7F2]/90 backdrop-blur px-3 py-1 text-xs font-semibold text-[#5E6B52]">
          {overnight ? "Alojamiento" : "Por el día"}
        </span>
      </div>
      <div className="p-6 sm:p-7 flex flex-col flex-1">
        <h3 className="font-serif text-2xl">{e.name}</h3>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed flex-1">{e.short}</p>
        <div className="mt-4 flex flex-wrap gap-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />
            {overnight ? `Check-in ${e.hora_inicio} · Check-out ${e.hora_fin}` : `${e.hora_inicio} a ${e.hora_fin}`}</span>
          {e.max_people > 0 && <span className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5" />Hasta {e.max_people}</span>}
          {e.slug === "cabana" && <span className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5" />Hasta {e.base_guests}</span>}
        </div>
        <div className="mt-5 pt-5 border-t border-border flex items-end justify-between">
          <div data-testid={`experience-price-${e.slug}`}>
            {p > 0 ? (
              <><span className="text-xs text-muted-foreground">Desde</span>
                <p className="font-serif text-2xl">{clp(p)} <span className="text-xs font-sans text-muted-foreground">{PRICE_MODE_LABEL[e.price_mode]}</span></p></>
            ) : <p className="text-sm font-semibold text-[#C86D51]">Precio por confirmar</p>}
          </div>
          <button onClick={() => onSelect(e)} data-testid={`experience-book-${e.slug}`}
            className="h-11 w-11 rounded-full bg-[#5E6B52] text-white grid place-items-center transition-colors hover:bg-[#4A5540]" aria-label={`Reservar ${e.name}`}>
            <ArrowUpRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </article>
  );
}

export function Experiences({ experiences, onSelect }) {
  return (
    <section id="experiencias" className="py-16 sm:py-24 lg:py-28" data-testid="experiences-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="eyebrow">Experiencias</p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Elige cómo vivir Valle Alegre</h2>
          <p className="mt-4 text-muted-foreground text-base md:text-lg">Ven por el día, relájate en la tinaja, acampa o quédate a dormir en la cabaña.</p>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:pb-10">
          {experiences.map((e, i) => <ExperienceCard key={e.slug} e={e} i={i} onSelect={onSelect} />)}
        </div>
      </div>
    </section>
  );
}
